var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5 6.1875C5.12345 6.1875 4.8125 6.49845 4.8125 6.875V15.125C4.8125 15.5016 5.12345 15.8125 5.5 15.8125H16.5C16.8766 15.8125 17.1875 15.5016 17.1875 15.125V6.875C17.1875 6.49845 16.8766 6.1875 16.5 6.1875H5.5ZM5.5 4.8125H16.5C17.6359 4.8125 18.5625 5.73905 18.5625 6.875V15.125C18.5625 16.2609 17.6359 17.1875 16.5 17.1875H5.5C4.36405 17.1875 3.4375 16.2609 3.4375 15.125V6.875C3.4375 5.73905 4.36405 4.8125 5.5 4.8125Z",
    fill: "#9738FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0001 10.8484L17.4808 6.31184C17.7919 6.0941 18.2205 6.16974 18.4383 6.4808C18.656 6.79186 18.5804 7.22054 18.2693 7.43828L11.3943 12.2508C11.1576 12.4165 10.8425 12.4165 10.6058 12.2508L3.7308 7.43828C3.41974 7.22054 3.3441 6.79186 3.56184 6.4808C3.77958 6.16974 4.20826 6.0941 4.51931 6.31184L11.0001 10.8484Z",
    fill: "#9738FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.680e66c0cddb15f30658c7d203af3103.svg";
export { ForwardRef as ReactComponent };